export const questionType={
    PARAGRAPH:"Paragraph",
    DROPDOWN:"Dropdown",
    CHECKBOX:"Checkbox",
    RADIO:"Radio"
}

export const questionTypes = [
  { value: "Paragraph", label: "Paragraph" },
  { value: "Dropdown", label: "Dropdown" },
  { value: "Checkbox", label: "Checkbox" },
  { value: "Radio", label: "Radio" }
]
export const defaultOptions = [
  { label: "Option A", value: "" },
  { label: "Option B", value: "" }
]